var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuppression(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6963 70H8.30368C3.73665 70 0 66.3027 0 61.6914V8.30861C0 3.73887 3.69514 0 8.30368 0H61.6963C66.2633 0 70 3.69733 70 8.30861V61.7329C70 66.3027 66.2633 70 61.6963 70Z",
    fill: "#6691CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 35C60 48.8072 48.8072 60 35 60C21.1929 60 10 48.8072 10 35C10 21.1929 21.1929 10 35 10C48.8072 10 60 21.1929 60 35ZM35 25.625C33.8473 25.625 32.8363 26.2476 32.2912 27.1898C31.427 28.6837 29.5153 29.1942 28.0214 28.33C26.5275 27.4658 26.017 25.5542 26.8812 24.0602C28.4974 21.2662 31.526 19.375 35 19.375C40.1778 19.375 44.375 23.5723 44.375 28.75C44.375 32.8319 41.7663 36.3047 38.125 37.5916V38.125C38.125 39.8509 36.7259 41.25 35 41.25C33.2742 41.25 31.875 39.8509 31.875 38.125V35C31.875 33.2741 33.2742 31.875 35 31.875C36.7259 31.875 38.125 30.4759 38.125 28.75C38.125 27.0241 36.7259 25.625 35 25.625ZM35 50.625C36.7259 50.625 38.125 49.2259 38.125 47.5C38.125 45.7741 36.7259 44.375 35 44.375C33.2741 44.375 31.875 45.7741 31.875 47.5C31.875 49.2259 33.2741 50.625 35 50.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppression);
export default __webpack_public_path__ + "static/media/suppression.7564ca5cd94f0aed70942492dfa063e0.svg";
export { ForwardRef as ReactComponent };